import styled from 'styled-components'

import { ContentExpand } from './ContentExpand'

export const ContentCenter = styled(ContentExpand)`
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 16px;
	text-align: center;
`
